import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { BoxModal } from '../../boxModal';
import { GoPlus } from 'react-icons/go';
import './cartao-manageCard-modal.css';
import { ModalRequestCard } from '../cartao-RequestCard-modal/cartao-RequestCard-modal';
import { toast } from 'react-toastify';
import { MdLockOpen, MdLockOutline, MdReplay } from 'react-icons/md';
import { IoChevronForward } from 'react-icons/io5';
import { LuCopyCheck, LuCopy } from "react-icons/lu"
import { RiSettings4Fill } from 'react-icons/ri';
import { ConfigMode } from './CardConfigMode';
import { ModalSecondCopyRequest } from '../cartao-secondCopyRequest-modal/cartao-secondCopyRequest-modal';
import CreditLimitModal from '../cartao-credit-limit-modal/cartao-credit-limit-modal';
import { CardType } from '../../../services/enums';
import { useCards } from '../../../hooks/useCards';
import { cardTypes } from '../../../utils/enums/cardEnums';

export const ManageCard = ({ isOpen, onClose, cards, getCards, cardRequests, setActiveModal }) => {
  const maxCardCount = 6;
  const cardCount = cards?.length + cardRequests?.length;
  
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [isConfigMode, setIsConfigMode] = useState(false);
  const [isSecondCardRequest, setIsSecondCardRequest] = useState(false);
  const [isPagarAtivado, setIsPagarAtivado] = useState(false);
  const [isRequestCardModalOpen, setIsRequestCardModalOpen] = useState(false);
  const [isLastFourDigitsCopied, setIsLastFourDigitsCopied] = useState(false);
  const [isAddLimitModal, setIsAddLimitModal] = useState(false);
  const [isCardLimitReached] = useState(cardCount >= maxCardCount);

  const [blockLoading, setBlockLoading] = useState(false);

  const { updateCard, selectedCard, setSelectedCard } = useCards();
  
  const isNewCard = selectedCard?.blocked && selectedCard?.blockedReason === 'CARTAO_NOVO_SEM_DESBLOQUEIO';
  const handleCardClick = (card) => {
    setSelectedCard(card);
    setIsPagarAtivado(card.contactless);
    setIsConfigMode(false);
    setIsCardModalOpen(true);
  };

  function formatExpiryDate(expiry) {
    const [year, month] = expiry.split("-");
    return `${month}/${year.slice(-2)}`;
  }

  const handleAddLimitClick = () => {
    setIsConfigMode(false);
    setIsCardModalOpen(false);
    setIsAddLimitModal(true);
  };

  const handleSave = async() => {
    const payload = {
      id: selectedCard.id,
      contactless: isPagarAtivado,
    };

    const message = await updateCard(payload);

    if (message) {
      toast.success(message);
      const updatedCards = cards.map((c) =>
        c.id === selectedCard.id ? { ...c, contactless: isPagarAtivado } : c
      );
      getCards();
      setSelectedCard({ ...selectedCard, contactless: isPagarAtivado });

    }
  };

  const handleBackTocards = () => {
    setIsConfigMode(false);
    setIsCardModalOpen(false);
  };

  const toggleCardBlock = async (cardId, shouldBlock) => {
    if (isNewCard) {
      setActiveModal('Desbloquear Cartão');
      return;
    }
    setBlockLoading(true);
    const payload = {
      id: cardId,
      blocked: shouldBlock,
      blockedReason: shouldBlock ? 'TRANSACAO_NAO_PERMITIDA' : null,
    };
  
    const message = await updateCard(payload);
    await getCards();
    setSelectedCard((prev) => ({ ...prev, blocked: shouldBlock }));
    setBlockLoading(false);
  
    if (message) {
      toast.success(message);
    }
  };

  const handleSecondCopyRequestClick = () => {
    setIsCardModalOpen(false);
    setIsSecondCardRequest(true);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success('Copiado para a área de transferência!');
    setIsLastFourDigitsCopied(true);

    setTimeout(() => {
      setIsLastFourDigitsCopied(false);
    }, 3000);
  };
  const isCardBlockedBySecondCopy = (card) => {
    return card?.blocked &&
      ['CARTAO_ROUBADO', 'CARTAO_PERDIDO', 'CARTAO_INVALIDO'].includes(card?.blockedReason);
  }

  const getCardStatus = (card) => {
    if(isCardBlockedBySecondCopy(card)) return 'Segunda Via Solicitada';
    
    return card.blocked ? 'Bloqueado' : 'Ativo';
  };

  const handleConfigClick = () => setIsConfigMode(true);
  const closeAddLimitModal = () => setIsAddLimitModal(false);
  const togglePaySwitch = () => setIsPagarAtivado(!isPagarAtivado);
  const openRequestCardModal = () => setIsRequestCardModalOpen(true);
  const closeRequestCardModal = () => setIsRequestCardModalOpen(false);
  const closeSecondCardRequestModal = () => setIsSecondCardRequest(false);
  const closeConfigModeModal = () => setIsConfigMode(false);

  const resetStates = () => {
    setIsConfigMode(false);
    setIsSecondCardRequest(false);
    setIsAddLimitModal(false);
    setIsCardModalOpen(false);
  };

  return (
    <>
      <ReactModal
        isOpen={isOpen}
        className="manage-card-modal"
        overlayClassName="overlay-manage-card-modal"
      >
        <div className='modal-container'>
          <div className="modal-header">
              <h2 className="modal-title">Meus Cartões</h2>
              <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
              <h3 className="section-title">Cartões</h3>

              <div className='cards-list'>
                {cards.map((card, index) => (
                  <div className="card-item" key={index} onClick={() => getCardStatus(card) === 'Segunda Via Solicitada' ? null : handleCardClick(card)}>
                    <div className="card-info">
                        <div className="card-icon">💳</div>
                        <div className="card-details">
                            <div className="card-holder">{card.cardholder}</div>
                            <div className="card-number">•••• •••• •••• {card.lastFour}</div>
                            <div className="card-type">{cardTypes[card.cardType]}</div>
                        </div>
                    </div>
                    <div className={`card-status ${card.blocked ? 'status-blocked' : 'status-active'}`}>{getCardStatus(card)}</div>
                    <IoChevronForward className="card-arrow" />
                  </div>
                ))}
              </div>
              
              <h3 className="section-title">Solicitações</h3>
              
              <div className='cards-list'>
                {cardRequests.map((request, index) => (
                  <div className="request-item" key={index}>
                    <div className="card-info">
                        <div className="card-icon">⏳</div>
                        <div className="card-details">
                          <div className="card-holder">{request.nomeCliente}</div>
                          <div className="card-number">•••• •••• •••• ••••</div>
                        </div>
                    </div>
                    <div className="card-status status-pending">Em andamento</div>
                  </div>
                ))}
              </div>
              
              <div
                onClick={isCardLimitReached ? null : openRequestCardModal}
                title={isCardLimitReached ? 'Número máximo de cartões atingido' : ''}
                className={`add-card ${isCardLimitReached ? ' disabled' : ''}`}
              >
                <GoPlus className="icon-button-manageCard" />
                <span
                  className={isCardLimitReached ? '' : 'manage-card-button'}
                >
                  Solicitar cartão adicional
                </span>
              </div>
          </div>
          <div className="modal-footer">
              <button className="btn btn-outline" onClick={onClose}>Fechar</button>
          </div>
        </div>
      </ReactModal>
      {selectedCard && (
        <ReactModal
          isOpen={isCardModalOpen}
          className="change-modal"
          overlayClassName="overlay-change-password-modal"
        >
          <BoxModal
            maxWidth={550}
            title={`Gerenciamento do cartão`}
            close={() => resetStates()}
          >
            <div className="card-details-container">       
              <label className="card-detail-label">Nome</label>
              <p className="card-detail-text">{selectedCard.cardholder}</p>
              
              <label className="card-detail-label">Número</label>
              <div className="card-detail-number-container">
                <p className="card-detail-text">**** **** **** {selectedCard.lastFour}</p>
                {
                  isLastFourDigitsCopied &&
                  <LuCopyCheck 
                    className="icon-number-copy"
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                  />
                }
                {
                  !isLastFourDigitsCopied &&
                  <LuCopy
                    className="icon-number-copy"
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    title="Copiar"
                    onClick={() => copyToClipboard(selectedCard.lastFour)}
                  />
                }
              </div>
              
              <div className="card-validity-cvv">
                <div>
                  <label className="card-detail-label">Validade</label>
                  <p className="card-detail-text">
                    {formatExpiryDate(selectedCard.expirationDate)}
                  </p>
                </div>
              </div>
              
              <div className="card-validity-cvv">
                <div>
                  <label className="card-detail-label">Tipo</label>
                  <p className="card-detail-text">
                    {cardTypes[selectedCard.cardType]}
                  </p>
                </div>
              </div>
              
              <div className="icons-container">
                <div className="icon-item">
                  <div className="icon-wrapper" onClick={blockLoading ? null : () => toggleCardBlock(selectedCard.id, !selectedCard.blocked)} >
                    { selectedCard.blocked ? <MdLockOpen className="icon-action" /> : <MdLockOutline className="icon-action" /> }
                  </div>
                  <div className="label-wrapper">
                    <span className="icon-label">{blockLoading ? "Carregando..." : selectedCard.blocked ? "Desbloquear" : "Bloquear"}</span>
                  </div>
                </div>
                <div className="icon-item" onClick={handleConfigClick}>
                  <RiSettings4Fill className="icon-action" />
                  <span className="icon-label">Configurar</span>
                </div>

                {selectedCard.cardType === CardType.CREDIT && <div className="icon-item" onClick={handleAddLimitClick}>
                  <RiSettings4Fill className="icon-action" />
                  <span className="icon-label">Adicionar Limite</span>
                </div>}

                {!isNewCard && <div className="icon-item" onClick={handleSecondCopyRequestClick}>
                  <MdReplay className="icon-action" />
                  <span className="icon-label">Solicitar Segunda Via</span>
                </div>}
              </div>
              <button onClick={handleBackTocards} className="close-button-manageCard" >
                Voltar
              </button>
            </div>
          </BoxModal>
        </ReactModal>
      )}
      <ConfigMode
        isConfigMode={isConfigMode}
        handleBackToCardList={closeConfigModeModal}
        isPagarAtivado={isPagarAtivado}
        togglePaySwitch={togglePaySwitch}
        handleSave={handleSave}
        handleBackTocards={handleBackTocards}
        />

      <ModalSecondCopyRequest
        isOpen={isSecondCardRequest}
        onClose={closeSecondCardRequestModal}
        card={selectedCard}
      />
      <CreditLimitModal
        isOpen={isAddLimitModal}
        onClose={closeAddLimitModal}
        card={selectedCard}
      />
      <ModalRequestCard
        isOpen={isRequestCardModalOpen}
        onClose={closeRequestCardModal}
        cardType={"credit"}
      />
    </>
  );
};
